/* eslint-disable react/react-in-jsx-scope */
import { TabPanel, TabView } from 'primereact/tabview';
import { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';

import { useParams } from 'react-router-dom';
import { AGENTROLE, ROLES, SUPERVISORROLE } from '../../constants';
import { useGetCaManagerTlSearchQuery } from '../../features/correctiveActions/managerTlViewSearch/CaMangerTLView.slice';
import { CaMenuTabindex } from '../../utils/typeConstants';
import {
    selectCurrentEmpid,
    selectCurrentIsAdmin,
    selectCurrentIsHC,
    selectCurrentRole,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsDelegate,
    selectIsPseudoSupervisor,
} from '../login/authSlice';
import { CorrectiveActionsAssignment } from './CorrectiveActionsAssignment';
import { MyCorrectiveActionsAssignment } from './MyCorrectiveActionsAssignment';
import { PendingApprovals } from './PendingApprovals';
import { Records } from './Records';
import Conversation from '../../components/conversation/Conversation';

export const CaMenu = () => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const loggedUser = useSelector(selectCurrentUser);
    const loggedRole = useSelector(selectCurrentRole);
    const isDelegate = useSelector<boolean | undefined | null>(selectIsDelegate);
    const [activeIndex, setActiveIndex] = useState<number>(
        loggedRole === AGENTROLE ? CaMenuTabindex.MyCorrectiveActions : CaMenuTabindex.AssignmentUpdates
    );
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isHC = useSelector(selectCurrentIsHC);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);

const { TabId, via, employeeNumber, coachingActionPlanId, scorecardVersionId, correctiveActionId,correctiveActionDate } = useParams();
    const { data: employeeCorrectiveActionsData } = useGetCaManagerTlSearchQuery(
        {
            employeeNumber: loggedEmpNum,
            isApprovals: true,
        },
        {
            skip: !loggedEmpNum,
        }
    );

    useEffect(() => {
        renderTabs();
    }, [isHC,userManagerLevel,isPseudoSupervisor,TabId]);

    const renderTabs = () => {
        

        if(TabId) {
            setActiveIndex(Number(TabId));
            return;
        }

        if (localStorage.getItem('caid') === '1') {
            setActiveIndex(CaMenuTabindex.NeedsAction);
            localStorage.removeItem('caid');
            return;
        } else if (localStorage.getItem('caid') === '2') {
            setActiveIndex(CaMenuTabindex.MyCorrectiveActions);
            localStorage.removeItem('caid');
            return;
        }
        
        if (employeeCorrectiveActionsData?.data?.length > 0) {
            setActiveIndex(CaMenuTabindex.NeedsAction);
            return;
        }
        if (loggedRole === AGENTROLE) {
            setActiveIndex(CaMenuTabindex.MyCorrectiveActions);
            return;
        }
        if (isAdmin || isHC) {
                setActiveIndex(CaMenuTabindex.Records);
                return;
        }
        if (isPseudoSupervisor || ROLES.SupervisorOrOnlyManager.includes(userManagerLevel)) {
            setActiveIndex(CaMenuTabindex.AssignmentUpdates);
            return;
        } 

        setActiveIndex(CaMenuTabindex.MyCorrectiveActions);

    };

    return (
        <div>
            <div className="card shadow bg-body rounded mt-3 border-0">
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-4 text-start">
                            <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                                {`Hello ${loggedUser}!`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                {(isPseudoSupervisor || isHC || ROLES.SupervisorOrOnlyManager.includes(userManagerLevel)) && (
                                    <TabPanel header="Assignment & Updates">
                                        <CorrectiveActionsAssignment
                                            source={via}
                                            employeeNumber={employeeNumber}
                                            correctiveActionId={correctiveActionId ? Number(correctiveActionId) : undefined}
                                            correctiveActionDate={correctiveActionDate ? new Date(correctiveActionDate) : undefined}
                                            coachingActionPlanId={coachingActionPlanId ? Number(coachingActionPlanId) : undefined}
                                            scorecardVersionId={scorecardVersionId ? Number(scorecardVersionId) : undefined}
                                        />
                                    </TabPanel>
                                )}

                                {(ROLES.SupervisorORManager.includes(userManagerLevel) ||
                                    isPseudoSupervisor) && employeeCorrectiveActionsData?.data?.length > 0 && (
                                    <TabPanel header="Needs Action">
                                        <PendingApprovals
                                            pendingApprovals={employeeCorrectiveActionsData.data}
                                        />
                                    </TabPanel>
                                )}

                                {(loggedRole === SUPERVISORROLE ||
                                    loggedRole === AGENTROLE ||
                                    isPseudoSupervisor) && (
                                    <TabPanel header="My Corrective Actions">
                                        {!isDelegate ? (
                                            <MyCorrectiveActionsAssignment />
                                        ) : (
                                            <p style={{ marginTop: '20px' }}>
                                                {
                                                    'My Corrective Action cannot be accessed in Delegation Mode.'
                                                }
                                            </p>
                                        )}
                                    </TabPanel>
                                )}

                                {(isAdmin || isHC || ROLES.Manager.includes(userManagerLevel)) && (
                                    <TabPanel header="Records">
                                        <Records />
                                    </TabPanel>
                                )}
                                <TabPanel header="Discussions">
                                        <Conversation via="correctiveactions"/>
                                    </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
